exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".codentify-camera-img{width:4em;display:block;margin-top:.5em}.column-4{float:left;width:90%;padding:10px}.green-comment{color:#229954!important}.black-comment{color:#000!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4983bc31","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/_orderDetail.vue
// module id = XCX+
// module chunks = 83